import React from 'react'
import SVG from 'react-inlinesvg';
import {Flex} from '/app/src/component'

class TabIcons extends React.Component {
    render() {
        const size = '30px'
        let blue = '#4ec1e0'
        let grey = '#c6c6c6'
        let border = {borderBottom: '5px solid transparent'}
        let {active, text, onClick} = this.props

        let fill = grey
        if(active){
            fill = blue
            border = {borderBottom: '5px solid #4ec1e0'};
        }

        return <Flex center color={fill} onClick={onClick} h='70px' w='100%' shrink={0} style={border} fontSize='20px'>
                <SVG cacheGetRequests={true} style={{fill: fill, width: size, height: size}} src={this.props.svgSrc}/>
                <Flex ml='2px'>
                    {text}
                </Flex>
        </Flex>
    }
}

export default TabIcons;



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/ClientChatMenu/HelpDesk/CategoryUpdate/TabIcon/index.js